<template>
  <div>
    <el-dialog
      title="导入PPT"
      :visible.sync="visible"
      :before-close="handleClose"
      width="420px"
    >
    <div class="ppt-txt">
      <p class="rate">PPT{{rate}}</p>
      <p class="warn">(关闭窗口不影响ppt导入，导入完成会生成新的课件)</p>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="handleEnd()">结 束</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ppt-upload-status',
  props: {
    rate: [String, Number],
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleEnd () {
      this.$emit('end')
    }
  }
}
</script>
<style lang="scss" scoped>
.ppt-txt{
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .rate{
        font-size: 18px;
        font-family: Helvetica;
        color: #303133;
        line-height: 14px;
        margin-bottom: 22px;
    }
    .warn{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 20px;
    }
}
</style>
